$(document).ready(function () {

    let saveForLater = localStorage.getItem('saveForLater');
    if (saveForLater !== null) {
        $("#saveForLaterCount").text(JSON.parse(saveForLater).length)
        let count = JSON.parse(saveForLater)
        $(".wishlist-btn i").after(`
        <sup style="top:0; right: 0" class="position-absolute badge rounded-pill bg-danger save-for-later-count">${count.length}</sup>`)
        if (JSON.parse(saveForLater).length === 0) {
            $(".output-saveForLater").append('<h3>Vaša lista želja je prazna</h3>')
        }
    }




    // add item to cart array inside local storage of a browser
    $(".add-to-save-for-later").click(function (e) {
        $.ajax({
            url: "/ajaxProduct",
            type: 'GET',
            data: {
                id: $("#product_id").val()
            },
            success: function (response) {

                response['price'] = $(".price").text()
                let saveForLater = JSON.parse(localStorage.getItem('saveForLater'));
                if (saveForLater == null) {
                    saveForLater = []
                } else {

                }
                let validation = true;
                for (let i = 0; i < saveForLater.length; i++) {
                    if (saveForLater[i].id === response['id']) {
                        toastr.warning("Ovaj model ste već sačuvali")
                        validation = false;
                    }
                }
                if (validation === true) {
                    response['quantity'] = 1;
                    saveForLater.push(response)
                    localStorage.setItem('saveForLater', JSON.stringify(saveForLater));
                    toastr.success("Trenutno sačuvanih modela:" + saveForLater.length, response['title'] + ' uspješno dodat')
                    $(".save-for-later-count").text(saveForLater.length)
                    // toastr('success', response['title'] + ' uspjesno dodat. Trenutno sačuvanih modela: ' + saveForLater.length)
                }


            }


        });
    })

    // render save for later page
    if($("#page-saveForLater").length && saveForLater !== null){
        const data = JSON.parse(saveForLater)
        let sum = 0;

        for (let i = 0; i < data.length; i++) {
            $(".output-saveForLater").append(
                `<div class="col-6 col-md-4 saveForLater-item text-end position-relative" data-attribute-id="${data[i].id}">
                        <div style="display: block; position: absolute; left: 1.5em; top: 1.5em; z-index: 2">
                            <a class="lightbox-icon" href="img/products/${data[i].image1}" data-lightbox="img" data-title="${data[i].title}"><i class="text-primary fa-2x fas fa-search"></i></a>
                        </div>
                        <a class="text-primary" href="/${data[i].slug}"><img class="w-100" src="img/products/thumb/${data[i].thumbnail}" alt=""></a>
                        <h4 class="my-2">
                            <a class="text-primary text-decoration-none" href="/${data[i].slug}">${data[i].title}</a>
                        </h4>
                        <p class="itemPrice my-0 py-0"><span class="text-primary" style="font-size: 1.2em">${data[i].price_per_item}/kom</span> €
                        </p>
                        <p style="display: block; position: absolute; right: 1.5em; top: 1.5em; cursor: pointer; z-index: 3" class="button-delete"><i class="fas fa-2x fa-times"></i></p
                        <hr>
                    </div>`
            )
        }
        updateTotals(data)
    }


    // delete item from a saveForLater
    let buttonsDelete = document.querySelectorAll('.button-delete');

    if (buttonsDelete.length > 0) {
        buttonsDelete.forEach((button)=>{
            button.addEventListener('click', (e)=>{
                let saveForLater = localStorage.getItem('saveForLater')
                if (saveForLater.length > 0) {
                    let data = JSON.parse(saveForLater)
                    let productId = button.parentElement.getAttribute('data-attribute-id');
                    for (let i = 0; i < data.length; i++) {
                        if (productId == data[i].id){
                            data.splice(i, 1)
                            localStorage.setItem('saveForLater', JSON.stringify(data));
                            $(button).parent().fadeOut()
                            toastr.error('Model uklonjen iz liste želja')
                            $(".save-for-later-count").text(data.length)
                        }
                    }
                    if (data.length === 0) {
                        $(".output-saveForLater").append('<h3>Vaša lista želja je prazna</h3>')
                        $("#checkoutBtnWrapper").remove()
                    }
                    updateTotals(data)
                }

            })
        })
    }


    // simulate order logic
    let checkout = document.querySelector('#checkout');

    if (checkout != null) {
        checkout.addEventListener('click', ()=>{
            let data = JSON.parse(localStorage.getItem('saveForLater'))
            updateTotals(data, true)
        })
    }



    // argument passed in is array of objects
    function updateTotals(data, modal = false){
        let totals = {};
        totals['sum'] = 0;
        for (let i = 0; i < data.length; i++){

            if (data[i].discount == 1){
                totals['sum'] += parseFloat(data[i].price_discount) * parseInt(data[i]['quantity'])
            }
            else {
                totals['sum'] += parseFloat(data[i].price) * parseInt(data[i]['quantity'])
            }
        }
        totals['count'] = data.length;
        totals['sum'] = totals['sum'].toFixed(2)
        $("#totalCount").text('Ukupno modela: ' + totals['count'])
        if (modal) {
            $("#checkoutItems").text('Ukupno modela: ' + totals['count'])
        }
    }
});
